import React, { FC } from 'react'

import { setStyle, buildStyles } from 'shared/styleHelpers'
import './AmbassadorChallenge.less'
import { AmbassadorChallengeBlock } from './AmbassadorChallengeBlock'
import { AmbassadorInitiativeBlock } from './AmbassadorInitiativeBlock'
// import { Modal } from './Modal'
// import { ManualDonationForm } from './ManualDonationForm'

interface StyleProps {
    subTitleStyle?: CSSProperties
    titleStyle?: CSSProperties
    progressStyle?: CSSProperties
}

interface DataProps {
    showModule: boolean
    ambassadorSettings?: AmbassadorSettingsDto
    data?: InitiativeDataRecord[]
    challengeData?: ChallengeDataRecord[]
    currentIndex?: number
    challengeCurrentIndex?: number
    selectedChallengeIndex: number
    afterSocialShareUrl?: string
    onAmbassadorProfile: boolean
    ambassadorProfile: AmbassadorProfileRecord
}

interface FunctionsToProps {
    getDaysRemaining: (EndDate: string) => string
    getConvertedCurrencyValue: (value: number) => string
    getFormatedDate: (date: string) => string
    getPercentageFunded: (currentValue: number, goalvalue: number) => number
    changeInitiativeIndex: (mode: string, currentIndex: number, totalLength: number, callback: (index: number) => void) => void
    updateSelectedChallengeIndex: (index: number) => void
    updateOnAmbassadorProfile: (flag: boolean) => void
    getChallenge?: any
    updateCurrentIndex?: any
    toggleModal: () => void
    showModal?: boolean
    updateChallengeCurrentIndex?: any
    updateAfterSocialShareUrl?: any
    updateAfterSocialShare?: any
    getAmbassadorProfile?: any
}

export type AmbassadorContentBlockProps = StyleProps & DataProps & FunctionsToProps

export type RenderStylesProps = AmbassadorContentBlockProps & { ambassadorSettings: AmbassadorSettingsDto }

// export components as named exports
export const RenderStyles: FC<RenderStylesProps> = ({ ...props }) => {
    const { scoreboardInstanceSettingsId } = props.ambassadorSettings
    return (
        <>
            {props.titleStyle && setStyle(` .scoreboard-id-${scoreboardInstanceSettingsId} h2 ${buildStyles(props.titleStyle)} `)}
            {props.subTitleStyle && setStyle(`.scoreboard-id-${scoreboardInstanceSettingsId} h3 ${buildStyles(props.subTitleStyle)}`)}
            {props.progressStyle && setStyle(`.scoreboard-id-${scoreboardInstanceSettingsId} progress-bar .button .bottom-right .bottom-left ${buildStyles(props.progressStyle)}`)}
        </>)
}

let prevIndex = -1
let prevChallengeIndex = -1
let prevAfterSocialShareUrl = ''

export const AmbassadorContentBlock: FC<AmbassadorContentBlockProps> = props => {
    if (!props.ambassadorSettings) {
        return (<div className="scoreboard-container"> no title </div>)
    }

    const { scoreboardInstanceSettingsId } = props.ambassadorSettings
    const initiativeDataList = props.data ? props.data : []
    const challengeDataList = props.challengeData ? props.challengeData : []
    const currentIndex = props.currentIndex ? props.currentIndex : 0
    const challengeCurrentIndex = props.challengeCurrentIndex ? props.challengeCurrentIndex : 0
    const afterSocialShareUrl = props.afterSocialShareUrl ? props.afterSocialShareUrl : ''
    const currentInitiativeData = initiativeDataList[currentIndex] ? initiativeDataList[currentIndex] : null
    const getChallenge = props.getChallenge
    const updateChallengeCurrentIndex = props.updateChallengeCurrentIndex
    const updateAfterSocialShareUrl = props.updateAfterSocialShareUrl
    const updateAfterSocialShare = props.updateAfterSocialShare
    const selectedChallengeIndex = props.selectedChallengeIndex
    const updateSelectedChallengeIndex = props.updateSelectedChallengeIndex
    const onAmbassadorProfile = props.onAmbassadorProfile
    const updateOnAmbassadorProfile = props.updateOnAmbassadorProfile

    if (prevAfterSocialShareUrl !== afterSocialShareUrl && afterSocialShareUrl !== '') {
        prevAfterSocialShareUrl = afterSocialShareUrl
        updateAfterSocialShare()
    }
    if (initiativeDataList.length > 0) {
        if (prevIndex !== currentIndex) {
            prevIndex = currentIndex
            prevChallengeIndex = -1
            if (updateChallengeCurrentIndex) {
                updateChallengeCurrentIndex(0)
            }
        }
        if (prevChallengeIndex !== challengeCurrentIndex) {
            prevChallengeIndex = challengeCurrentIndex
            if (getChallenge) {
                getChallenge()
            }
        }
    }
    if (!props.showModule) {
        return (<div className="scoreboard-container" />)
    }
    // const changeDataIndex = (mode: string) => {
    //     if (mode === '-' && currentIndex > 0) {
    //         props.updateCurrentIndex(currentIndex - 1)
    //         return
    //     }
    //     if (mode === '+' && (currentIndex < initiativeDataList.length - 1)) {
    //         props.updateCurrentIndex(currentIndex + 1)
    //         return
    //     }
    // }
    return (
        <>
            <RenderStyles {...props} ambassadorSettings={props.ambassadorSettings} />
            <div className="ambassadorContentBlock" id="ambassadorContentBlockId">
                <div className={`scoreboard-id-${scoreboardInstanceSettingsId}`}>
                    <div className="scoreboard-container">
                        <h2>{props.ambassadorSettings.moduleTitle}</h2>
                        <h3>{props.ambassadorSettings.moduleSubTitle}</h3>
                    </div>
                    {
                        currentInitiativeData &&
                        <div key={currentInitiativeData.FundraisingInitiativeId} className="scoreboard-container">
                            <div className="cpi-container" style={{ padding: "15px" }}>
                                <div className="initiative-wrapper">
                                    <div className="text-center font-values" style={{ marginBottom: "20px" }}>{currentInitiativeData.FundraisingInitiativeName}</div>
                                    <div className='row initiative-arrow'>
                                        <div className="col-md-12 col-sm-12 d-flex align-items-center justify-content-between initiative-col-row" style={{ padding: "10px" }}>
                                            <span
                                                className={currentIndex > 0 ? 'arrow-icon' : 'arrow-icon arrow-disable'}
                                                onClick={props.changeInitiativeIndex.bind(null, '-', currentIndex, initiativeDataList.length, props.updateCurrentIndex)}
                                            >
                                                <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-chevron-compact-left" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223z" />
                                                </svg>
                                            </span>
                                            <div className="row" style={{ width: '100%' }}>
                                                <AmbassadorInitiativeBlock
                                                    data={currentInitiativeData}
                                                    getPercentageFunded={props.getPercentageFunded}
                                                    getConvertedCurrencyValue={props.getConvertedCurrencyValue}
                                                />
                                            </div>
                                            <span
                                                className={(currentIndex < initiativeDataList.length - 1) ? 'arrow-icon' : 'arrow-icon arrow-disable'}
                                                onClick={props.changeInitiativeIndex.bind(null, '+', currentIndex, initiativeDataList.length, props.updateCurrentIndex)}
                                            >
                                                <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-chevron-compact-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671z" />
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="scoreboards-render-root-bootstrap">
                                    <AmbassadorChallengeBlock getAmbassadorProfile={props.getAmbassadorProfile} toggleModal={props.toggleModal} data={challengeDataList} getPercentageFunded={props.getPercentageFunded} getConvertedCurrencyValue={props.getConvertedCurrencyValue} getDaysRemaining={props.getDaysRemaining} onPageChange={updateChallengeCurrentIndex} onAfterSocialShare={updateAfterSocialShareUrl} selectedChallengeIndex={selectedChallengeIndex} updateSelectedChallengeIndex={updateSelectedChallengeIndex} onAmbassadorProfile={onAmbassadorProfile} updateOnAmbassadorProfile={updateOnAmbassadorProfile} ambassadorProfile={props.ambassadorProfile} sortBy={props.ambassadorSettings.sortBy} />
                                </div>
                            </div>
                            {/* <Modal toggleModal={props.toggleModal} showModal={props.showModal} title="Add Donation">
                                <ManualDonationForm toggleModal={props.toggleModal} />
                            </Modal> */}
                        </div>
                    }
                </div>
            </div>
        </>
    )
}
